<div class="slt-host" [style.top.px]="posY">

  <!-- Compact icon-only half-circle tab -->
  <div class="slt-tab"
    (mousedown)="onDragStart($event)"
    (touchstart)="onDragStart($event)"
    (click)="toggle()"
    [class.slt-tab--open]="isOpen"
    pTooltip="{{ label }}"
    tooltipPosition="left">
    <i class="ri-checkbox-circle-fill slt-tab-icon"></i>
    <i class="slt-tab-chevron ri-arrow-left-s-line" [class.slt-chevron--open]="isOpen"></i>
  </div>

  <!-- Slide-out panel -->
  <div class="slt-panel" *ngIf="isOpen" [@slideIn]>
    <div class="slt-panel-head">
      <div class="slt-panel-head-left">
        <i class="ri-checkbox-circle-fill"></i>
        <span>{{ label }}</span>
      </div>
      <button class="slt-close" (click)="toggle()">
        <i class="ri-close-line"></i>
      </button>
    </div>
    <div class="slt-panel-body">
      <ng-content></ng-content>
    </div>
  </div>

</div>
